import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './banner-three-step-promo.component.scss';
var BannerThreeStepPromo = /** @class */ (function (_super) {
    tslib_1.__extends(BannerThreeStepPromo, _super);
    function BannerThreeStepPromo(element) {
        return _super.call(this, element) || this;
    }
    BannerThreeStepPromo.prototype.init = function () {
    };
    BannerThreeStepPromo.prototype.bindEvents = function () {
    };
    return BannerThreeStepPromo;
}(Base));
export { BannerThreeStepPromo };



//////////////////
// WEBPACK FOOTER
// ./components/banner-three-step-promo/banner-three-step-promo.component.ts
// module id = 146
// module chunks = 0